import styled from "styled-components";
import {
	Avatar as AntAvatar,
	Input as AntInput,
	Button as AntButton,
	Form as AntForm,
} from "antd";
import { NoImageUser } from "@assets";

export const RootContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	position: relative;
	margin: 0 16px;
	min-height: calc(100vh - 70px);
	gap: 32px;
	overflow: hidden;
`;

export const AvatarWrapper = styled.div`
	margin: 16px 0 0;
`;

export const Avatar = styled(AntAvatar)`
	border-radius: 12px !important;
`;

export const ProfileInputContainer = styled.div`
	position: absolute;
  bottom: 0px;
	left: 0px;
	width: 120px;
	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
  border-radius: 0px 0px 12px 12px;
  opacity: 0.8;
  background: var(--dark-blue-text, #13100F);

  svg{
    width: 24px;
    height: 24px;
  }
`;

export const InputLabel = styled.p`
	position: absolute;
	left: 24px;
	top: -8px;
	z-index: 30;
	margin: 0px;
	padding: 0px 4px;
	color: #535b5d;
	background-color: white;
	font-family: Plus Jakarta Sans;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`;



export const FileInput = styled.input`
	display: none;
`;

export const SaveButton = styled(AntButton)`
	box-sizing: border-box !important ;
	/* position: fixed; */
	/* bottom: 16px; */
	/* width: calc(100% - 32px) !important; */
	/* max-width: 442px; */
  width: 100%;
	height: 52px;
	margin: 260px 16px 10px;

  @media screen and (max-height: 800px) {
		margin: 210px 16px 10px;
	}

  @media screen and (max-height: 750px) {
		margin: 160px 16px 10px;
	}

  @media screen and (max-height: 700px) {
		margin: 110px 16px 10px;
	}

  @media screen and (max-height: 650px) {
		margin: 60px 16px 10px;
	}

`;

export const NoImageIcon = styled.img.attrs({
	src: `${NoImageUser}`,
	alt: "no_img",
})`
	margin-top: 4px;
	width: 120px;
	height: 120px;
  border-radius: 12px;
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;

	.ant-form-item {
		margin: 0 0 24px 0px;
	}

	/* .ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	} */
  .ant-form-item-label{
    padding-bottom: 0 !important;
  }

	.ant-form-item-label label {
		margin: 0px 0 0 18px;
    color:  #817774;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 0px !important;
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
	}
`;

export const Input = styled(AntInput)`
	border-radius: 8px;
	height: 52px;
	background-color: ${(props) =>
		props.inputType === "phone" ? "#DFDFDF" : "#FFF"};
	color: ${(props) => (props.inputType === "phone" ? "#8E969F" : "#342309")};

	font-size: 18px !important ;
	font-weight: 400;
	line-height: 22.5px;

	.ant-input {
		font-size: 17px !important;
	}

	.ant-input::placeholder {
		color: #686b6e;
		font-weight: 200;
		font-size: 18px;
	}

	&&& {
		padding-left: 16px;
	}



`;